import { useLoadingContext } from "../../contexts/useLoadingContext";
import "./Loading.scss";

/**
 * The Component is a transitional view during asynchronous processes  .
 *
 * @param {boolean} directlyshow - The flag to directly show the loading mask.
 * @returns {JSX.Element}
 */

const Loading = ({ directlyshow }) => {
    const { loadingFlag } = useLoadingContext();
    return (
        (directlyshow || loadingFlag) && (
            <div className="loading-mask" data-testid="loading-mask">
                <div className="loading-content" data-testid="loading-animation"></div>
            </div>
        )
    );
};

export default Loading;
